import { render } from "./Discussion.vue?vue&type=template&id=27b39544&scoped=true"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"

import "./Discussion.vue?vue&type=style&index=0&id=27b39544&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b39544"]])

export default __exports__